import { keyframes } from "@mui/material/styles";

const iconPop = keyframes`
  0% { transform: scale(1); }
  40% { transform: scale(1.2) rotate(-6deg); }
  100% { transform: scale(1) rotate(0); }
`;

export const activeIconStyle = {
  "@media (prefers-reduced-motion: no-preference)": {
    animation: `${iconPop} 400ms cubic-bezier(0.2, 0, 0, 1)`,
  },
};
